"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CARD_STYLE_OPTIONS = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _constants = require("@insided/deprecated-libs/constants");

var _fullImage = _interopRequireDefault(require("./style-icons/full-image"));

var _icon = _interopRequireDefault(require("./style-icons/icon"));

var _textOnly = _interopRequireDefault(require("./style-icons/text-only"));

var _reactModal = _interopRequireDefault(require("@insided/deprecated-components/reactModal"));

var _AddQuickLinkImageCropper = _interopRequireWildcard(require("./AddQuickLinkImageCropper"));

var _Checkmark = _interopRequireDefault(require("@insided/shared/icons/Checkmark"));

var _Add = _interopRequireDefault(require("@insided/shared/icons/Add"));

var _CardStyleSelect = _interopRequireDefault(require("./CardStyleSelect"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AccessibilityImageDisclaimer = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
  return _regenerator.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import('@insided/destination/modules/Customization/configurator/diclaimers');

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
var FILE_INPUT_ID = 'quick-link-file-input';
var defaultQuickLinkState = {
  title: '',
  url: '',
  description: '',
  openNewTab: false,
  imageSrc: null,
  iconSrc: null
};
var CARD_STYLE_OPTIONS = [{
  type: 'none',
  label: 'Text only',
  qaClassName: 'qa-None',
  component: (0, _preact.h)(_textOnly.default, null)
}, {
  type: 'image',
  label: 'Full Image',
  component: (0, _preact.h)(_fullImage.default, null),
  qaClassName: 'qa-Image',
  aspectRatio: _AddQuickLinkImageCropper.QUICK_LINK_MEDIA_ASPECT_RATIO.IMAGE
}, {
  type: 'icon',
  label: 'Icon',
  qaClassName: 'qa-Icon',
  component: (0, _preact.h)(_icon.default, null),
  aspectRatio: _AddQuickLinkImageCropper.QUICK_LINK_MEDIA_ASPECT_RATIO.ICON
}];
exports.CARD_STYLE_OPTIONS = CARD_STYLE_OPTIONS;

var getSelectedCardStyle = function getSelectedCardStyle(quickLink) {
  if (!quickLink) return 0;
  var needle = 'none';

  if (quickLink.imageSrc) {
    needle = 'image';
  }

  if (quickLink.iconSrc) {
    needle = 'icon';
  }

  return CARD_STYLE_OPTIONS.findIndex(function (option) {
    return option.type === needle;
  });
};

var AddQuickLinkSection = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddQuickLinkSection, _Component);

  var _super = _createSuper(AddQuickLinkSection);

  function AddQuickLinkSection(props) {
    var _ref2, _this$props$item$icon, _this$props$item, _this$props$item2, _this$props$item3;

    var _this;

    (0, _classCallCheck2.default)(this, AddQuickLinkSection);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isFormExtended: _this.props.item !== undefined,
      isModalOpen: false,
      fileUploadBlob: null,
      fileUploadFileName: null,
      fileUploadSrc: (_ref2 = (_this$props$item$icon = (_this$props$item = _this.props.item) === null || _this$props$item === void 0 ? void 0 : _this$props$item.iconSrc) !== null && _this$props$item$icon !== void 0 ? _this$props$item$icon : (_this$props$item2 = _this.props.item) === null || _this$props$item2 === void 0 ? void 0 : _this$props$item2.imageSrc) !== null && _ref2 !== void 0 ? _ref2 : null,
      originalFileUploadSrc: null,
      fileUploadErrorMessage: null,
      selectedCardStyle: getSelectedCardStyle(_this.props.item),
      quickLink: (_this$props$item3 = _this.props.item) !== null && _this$props$item3 !== void 0 ? _this$props$item3 : defaultQuickLinkState
    });
    _this.onUseImageHandler = _this.onUseImageHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSubmitHandler = _this.onSubmitHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancelHandler = _this.onCancelHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSelectedCardStyleChange = _this.onSelectedCardStyleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AddQuickLinkSection, [{
    key: "onSelectFile",
    value: function onSelectFile(e) {
      var inputElement = e.target;

      if (inputElement.files && inputElement.files.length > 0) {
        var _inputElement$files = (0, _slicedToArray2.default)(inputElement.files, 1),
            file = _inputElement$files[0];

        if (file.size > _constants.maxImageFileSize) {
          // 5MB
          this.setState({
            fileUploadErrorMessage: 'Size is more than 5MB'
          });
          return;
        }

        if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
          this.setState({
            fileUploadErrorMessage: 'File type is not supported'
          });
          return;
        }

        this.setState({
          fileUploadBlob: file,
          fileUploadSrc: URL.createObjectURL(file),
          originalFileUploadSrc: URL.createObjectURL(file),
          fileUploadErrorMessage: null,
          fileUploadFileName: file.name,
          isModalOpen: true
        });
        inputElement.value = '';
      }
    }
  }, {
    key: "onUseImageHandler",
    value: function onUseImageHandler(url) {
      var _this$state = this.state,
          quickLink = _this$state.quickLink,
          selectedCardStyle = _this$state.selectedCardStyle;

      if (CARD_STYLE_OPTIONS[selectedCardStyle].type === 'image') {
        this.setState({
          quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
            imageSrc: url
          }),
          isModalOpen: false,
          fileUploadSrc: url
        });
      }

      if (CARD_STYLE_OPTIONS[selectedCardStyle].type === 'icon') {
        this.setState({
          quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
            iconSrc: url
          }),
          isModalOpen: false,
          fileUploadSrc: url
        });
      }
    }
  }, {
    key: "onSubmitHandler",
    value: function onSubmitHandler() {
      var _this2 = this;

      var onSubmit = this.props.onSubmit;
      var quickLink = this.state.quickLink;
      onSubmit(quickLink, function () {
        return _this2.setState({
          isFormExtended: false,
          quickLink: defaultQuickLinkState
        });
      });
    }
  }, {
    key: "onCancelHandler",
    value: function onCancelHandler() {
      var onCancel = this.props.onCancel;
      this.setState({
        isFormExtended: false
      }, function () {
        return onCancel === null || onCancel === void 0 ? void 0 : onCancel();
      });
    }
  }, {
    key: "onSelectedCardStyleChange",
    value: function () {
      var _onSelectedCardStyleChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_, index) {
        var _item$imageSrc;

        var item, _this$state2, quickLink, fileUploadSrc, isTextOnly, hasExistingImage;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                item = this.props.item;
                _this$state2 = this.state, quickLink = _this$state2.quickLink, fileUploadSrc = _this$state2.fileUploadSrc;
                isTextOnly = index === CARD_STYLE_OPTIONS.findIndex(function (option) {
                  return option.type === 'none';
                });
                hasExistingImage = (_item$imageSrc = item === null || item === void 0 ? void 0 : item.imageSrc) !== null && _item$imageSrc !== void 0 ? _item$imageSrc : item === null || item === void 0 ? void 0 : item.iconSrc;
                this.setState({
                  selectedCardStyle: index,
                  isModalOpen: !isTextOnly,
                  fileUploadSrc: hasExistingImage ? null : fileUploadSrc,
                  quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
                    imageSrc: null,
                    iconSrc: null
                  })
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSelectedCardStyleChange(_x, _x2) {
        return _onSelectedCardStyleChange.apply(this, arguments);
      }

      return onSelectedCardStyleChange;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _quickLink$openNewTab;

      var item = this.props.item;
      var _this$state3 = this.state,
          quickLink = _this$state3.quickLink,
          isFormExtended = _this$state3.isFormExtended,
          selectedCardStyle = _this$state3.selectedCardStyle,
          fileUploadFileName = _this$state3.fileUploadFileName,
          fileUploadSrc = _this$state3.fileUploadSrc,
          originalFileUploadSrc = _this$state3.originalFileUploadSrc,
          fileUploadErrorMessage = _this$state3.fileUploadErrorMessage,
          isModalOpen = _this$state3.isModalOpen,
          fileUploadBlob = _this$state3.fileUploadBlob;
      var submitButtonText = item ? 'Save' : 'Add New Quick Link';
      var uploadImageButtonText = fileUploadSrc ? 'Edit image' : 'Upload Image';
      return (0, _preact.h)("div", {
        className: "quick-links-manager__add-quick-link-container"
      }, isFormExtended ? (0, _preact.h)("form", {
        className: "quick-links-manager__add-quick-link-form"
      }, (0, _preact.h)(_CardStyleSelect.default, {
        onSelectedCardStyleChange: /*#__PURE__*/function () {
          var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_, index) {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this3.onSelectedCardStyleChange(_, index);

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x3, _x4) {
            return _ref3.apply(this, arguments);
          };
        }(),
        selectedCardStyle: selectedCardStyle
      }), (0, _preact.h)(_InputGroup.default, {
        title: "Link Title",
        type: "text",
        required: true,
        maxlength: 30,
        onChange: function onChange(e) {
          return _this3.setState({
            quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
              title: e.target.value
            })
          });
        },
        value: quickLink === null || quickLink === void 0 ? void 0 : quickLink.title,
        formGroupClasses: "quick-links-manager__add-quick-link-input-group",
        qaClasses: "qa-quicklinks-input-title"
      }), (0, _preact.h)(_InputGroup.default, {
        title: "Description (optional)",
        type: "text",
        maxlength: 80,
        onChange: function onChange(e) {
          return _this3.setState({
            quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
              description: e.target.value
            })
          });
        },
        value: quickLink === null || quickLink === void 0 ? void 0 : quickLink.description,
        formGroupClasses: "quick-links-manager__add-quick-link-input-group",
        qaClasses: "qa-quicklinks-input-description"
      }), (0, _preact.h)(_InputGroup.default, {
        title: "URL",
        type: "url",
        required: true,
        onChange: function onChange(e) {
          return _this3.setState({
            quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
              url: e.target.value
            })
          });
        },
        value: quickLink.url,
        placeholder: "https://example.com",
        pattern: "https?://.+",
        formGroupClasses: "quick-links-manager__add-quick-link-input-group",
        qaClasses: "qa-quicklinks-input-url"
      }), (0, _preact.h)("div", {
        className: "form-group quick-links-manager__add-quick-link-input-group"
      }, (0, _preact.h)(_Checkbox.default, {
        label: "Open link in new tab",
        onUpdate: function onUpdate() {
          return _this3.setState({
            quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
              openNewTab: !quickLink.openNewTab
            })
          });
        },
        checked: (_quickLink$openNewTab = quickLink.openNewTab) !== null && _quickLink$openNewTab !== void 0 ? _quickLink$openNewTab : false
      })), ['image', 'icon'].includes(CARD_STYLE_OPTIONS[selectedCardStyle].type) && (0, _preact.h)("div", {
        className: (0, _classnames.default)('quick-links-manager__add-quick-link-upload-image', 'form-group', 'quick-links-manager__add-quick-link-input-group')
      }, (0, _preact.h)("label", {
        htmlFor: "quick-links-image-uploader",
        className: "quick_links_common_settings_title"
      }, "Image"), (0, _preact.h)("div", {
        className: "quick-links-manager__add-quick-link-upload-image-body",
        id: "quick-links-image-uploader"
      }, fileUploadBlob ? (0, _preact.h)(_Button.default, {
        type: "button",
        onClick: function onClick() {
          return _this3.setState({
            isModalOpen: true
          });
        }
      }, "Edit image") : (0, _preact.h)(_Button.default, {
        type: "button"
      }, (0, _preact.h)("label", {
        htmlFor: FILE_INPUT_ID,
        className: "quick-links-manager__add-quick-link-upload-image-label"
      }, uploadImageButtonText)), (0, _preact.h)("input", {
        type: "file",
        id: FILE_INPUT_ID,
        className: "quick-links-manager__add-quick-link-upload-image-input",
        onChange: function onChange(e) {
          return _this3.onSelectFile(e);
        },
        accept: "image/png,image/jpeg,image/webp"
      }), !fileUploadErrorMessage && fileUploadSrc && (0, _preact.h)("img", {
        className: "quick-links-manager__add-quick-link-upload-image-preview",
        width: 50,
        height: 32,
        alt: "image preview",
        src: (0, _absoluteUrlRuntime.resolveUrl)(fileUploadSrc)
      }), !fileUploadErrorMessage && (0, _preact.h)("span", {
        className: "quick-links-manager__add-quick-link-upload-image-filename"
      }, fileUploadFileName), !fileUploadErrorMessage && fileUploadBlob && (0, _preact.h)(_Checkmark.default, {
        width: 24,
        height: 24,
        fill: "#1D9B4B",
        className: "quick-links-manager__add-quick-link-upload-image-check"
      })), fileUploadErrorMessage && (0, _preact.h)("div", {
        className: "quick-links-manager__add-quick-link-upload-image-error"
      }, fileUploadErrorMessage), (0, _preact.h)(_InputGroup.default, {
        title: "Image Description",
        type: "text",
        onChange: function onChange(e) {
          _this3.setState({
            quickLink: _objectSpread(_objectSpread({}, quickLink), {}, {
              imageDescription: e.target.value
            })
          });
        },
        value: quickLink.imageDescription,
        disclaimer: (0, _preact.h)(AccessibilityImageDisclaimer, null)
      })), (0, _preact.h)("div", {
        className: "quick-links-manager__add-quick-link-action-group"
      }, (0, _preact.h)(_Button.default, {
        type: "button",
        variant: "success",
        className: "qa-quickLinks-submit",
        onClick: function onClick() {
          return _this3.onSubmitHandler();
        }
      }, submitButtonText), (0, _preact.h)(_Button.default, {
        type: "button",
        onClick: function onClick() {
          return _this3.onCancelHandler();
        }
      }, "Cancel"))) : (0, _preact.h)(_Button.default, {
        type: "button",
        startIcon: (0, _preact.h)(_Add.default, {
          width: 16,
          height: 16
        }),
        className: "quick-links-manager__add-quick-link-btn qa-quickLinks-add",
        onClick: function onClick() {
          return _this3.setState({
            isFormExtended: true,
            fileUploadBlob: null,
            fileUploadSrc: null,
            originalFileUploadSrc: null,
            fileUploadFileName: null
          });
        }
      }, "Add New Quick Link"), fileUploadBlob && (0, _preact.h)(_reactModal.default, {
        isOpen: isModalOpen,
        onClose: function onClose() {
          return _this3.setState({
            isModalOpen: false
          });
        }
      }, (0, _preact.h)("div", {
        className: "quick-link-modal"
      }, (0, _preact.h)(_AddQuickLinkImageCropper.default, {
        onCancel: function onCancel() {
          return _this3.setState({
            isModalOpen: false
          });
        },
        uploadImageInputId: FILE_INPUT_ID,
        onUseImage: function onUseImage(uploadedImageUrl) {
          return _this3.onUseImageHandler(uploadedImageUrl);
        },
        fileSource: originalFileUploadSrc !== null && originalFileUploadSrc !== void 0 ? originalFileUploadSrc : fileUploadSrc,
        aspectRatio: CARD_STYLE_OPTIONS[selectedCardStyle].aspectRatio,
        fileBlob: fileUploadBlob
      }))));
    }
  }]);
  return AddQuickLinkSection;
}(_preact.Component);

var _default = AddQuickLinkSection;
exports.default = _default;